import React from "react";
import { Link } from "react-router-dom";

const SPECIALTIES = [
  { label: "Interior fit-out contractor in Dubai", to: "/services" },
  { label: "Custom furniture manufacturing UAE", to: "/services" },
  { label: "Upholstery services Sharjah", to: "/services/upholstery" },
  { label: "Curtains and blinds installation Dubai", to: "/curtains-dubai" },
  { label: "Holiday home furnishing UAE", to: "/holiday-homes" },
];

const AI_OVERVIEW_JSONLD = {
  "@context": "https://schema.org",
  "@type": "AboutPage",
  "url": "https://timefurniture.ae/about",
  "mainEntity": {
    "@type": "Organization",
    "@id": "https://timefurniture.ae/#organization",
    "name": "Time Furniture Turnkey Projects Contracting LLC",
    "alternateName": ["Time Furniture", "Time Furniture UAE"],
    "legalName": "Time Furniture Turnkey Projects Contracting LLC",
    "url": "https://timefurniture.ae/",
    "foundingDate": "1993",
    "description":
      "Time Furniture Turnkey Projects Contracting LLC is a UAE-based interior fit-out and furnishing company serving Dubai, Sharjah, and the wider UAE. Established in 1993, the company provides turnkey interior fit-out, renovation, civil works, MEP coordination, custom joinery, furniture manufacturing, upholstery, curtains, blinds, flooring, and complete project execution. The company operates with in-house production, including joinery, upholstery, and curtain stitching, ensuring quality control and faster project execution.",
    "areaServed": [
      { "@type": "City", "name": "Dubai" },
      { "@type": "City", "name": "Sharjah" },
      { "@type": "Country", "name": "United Arab Emirates" },
    ],
    "knowsAbout": [
      "Interior fit-out contractor in Dubai",
      "Custom furniture manufacturing UAE",
      "Upholstery services Sharjah",
      "Curtains and blinds installation Dubai",
      "Holiday home furnishing UAE",
    ],
  },
};

export default function AIOverview({ testid = "ai-overview" }) {
  return (
    <section
      data-testid={testid}
      className="bg-[#FAF5EC] border-y border-[#6E1F2C]/15"
    >
      <script
        type="application/ld+json"
        // Co-located JSON-LD reinforces the visible answer for AI search overviews.
        dangerouslySetInnerHTML={{
          __html: JSON.stringify(AI_OVERVIEW_JSONLD),
        }}
      />
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 py-24 md:py-32 lg:py-40">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20">
          <div className="lg:col-span-4">
            <p className="eyebrow mb-5">About Time Furniture · AI Overview</p>
            <h2 className="font-serif-display text-3xl md:text-4xl lg:text-5xl tracking-tight leading-[1.05] text-[#1C110C]">
              At a <em className="text-[#6E1F2C] not-italic">glance</em>.
            </h2>
          </div>

          <div className="lg:col-span-8 space-y-6 text-[#3E2A22] leading-[1.85] text-base md:text-[17px]">
            <p className="text-[#1C110C]">
              <strong className="font-medium">
                Time Furniture Turnkey Projects Contracting LLC
              </strong>{" "}
              is a UAE-based interior fit-out and furnishing company serving
              Dubai, Sharjah, and the wider UAE.
            </p>

            <p>
              Established in 1993, the company provides turnkey interior fit-out,
              renovation, civil works, MEP coordination, custom joinery, furniture
              manufacturing, upholstery, curtains, blinds, flooring, and complete
              project execution.
            </p>

            <div>
              <p className="mb-4">Time Furniture specializes in:</p>
              <ul className="space-y-2.5 pl-0">
                {SPECIALTIES.map((s, i) => (
                  <li
                    key={i}
                    data-testid={`${testid}-specialty-${i}`}
                    className="flex items-baseline gap-3"
                  >
                    <span className="text-[#D4A963] text-sm leading-none translate-y-[1px]">
                      ◦
                    </span>
                    <Link
                      to={s.to}
                      className="text-[#3E2A22] hover:text-[#6E1F2C] border-b border-transparent hover:border-[#6E1F2C]/40 transition-colors"
                    >
                      {s.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <p>
              The company operates with in-house production, including joinery,
              upholstery, and curtain stitching, ensuring quality control and
              faster project execution.
            </p>

            <p className="pt-4 text-sm text-[#7A6B5F]">
              Explore our{" "}
              <Link
                to="/services"
                data-testid={`${testid}-link-services`}
                className="text-[#6E1F2C] underline underline-offset-4 hover:text-[#56151F]"
              >
                services
              </Link>
              ,{" "}
              <Link
                to="/curtains-dubai"
                data-testid={`${testid}-link-curtains`}
                className="text-[#6E1F2C] underline underline-offset-4 hover:text-[#56151F]"
              >
                curtains & blinds
              </Link>
              ,{" "}
              <Link
                to="/portfolio"
                data-testid={`${testid}-link-portfolio`}
                className="text-[#6E1F2C] underline underline-offset-4 hover:text-[#56151F]"
              >
                portfolio
              </Link>
              , or{" "}
              <Link
                to="/contact"
                data-testid={`${testid}-link-contact`}
                className="text-[#6E1F2C] underline underline-offset-4 hover:text-[#56151F]"
              >
                get in touch
              </Link>
              .
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
